import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { UserRound, Check } from "lucide-react";
import { toast } from "sonner";

export function DisplayNameEditor() {
  const { user, updateUser } = useAuth();
  const shown = user?.display_name || user?.name || "";
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(user?.display_name || "");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/me/display-name", { display_name: val.trim() });
      updateUser({ display_name: data.display_name });
      toast.success("Display name updated");
      setEditing(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't update your display name.");
    } finally { setBusy(false); }
  };

  if (!editing) {
    return (
      <div className="flex items-center gap-2 text-xs font-data text-muted-foreground py-1" data-testid="display-name-row">
        <UserRound size={13} />
        <span>Shown publicly as <span className="text-foreground font-bold" data-testid="display-name-value">{shown}</span></span>
        <button onClick={() => setEditing(true)} data-testid="display-name-edit"
          className="text-primary uppercase tracking-wider hover:underline">Change</button>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2 py-1" data-testid="display-name-editor">
      <Input value={val} onChange={(e) => setVal(e.target.value)} maxLength={24}
        placeholder="Pick a username" data-testid="display-name-input"
        className="rounded-none border-2 h-8 text-sm" />
      <Button size="sm" onClick={save} disabled={busy || !val.trim()} data-testid="display-name-save"
        className="rounded-none uppercase text-xs font-bold h-8"><Check size={13} /></Button>
      <Button size="sm" variant="ghost" onClick={() => setEditing(false)} className="h-8 text-xs">Cancel</Button>
    </div>
  );
}
